/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Epicrating2Inputs */

const id_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Pemain Epic`)
};

const ms_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian Pemain Epic`)
};

const da_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Spillerbedømmelse`)
};

const de_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Spielerbewertung`)
};

const en_us2_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Players Rating`)
};

const es_es2_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de jugadores de Epic`)
};

const es_mx2_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de jugadores de Epic`)
};

const fil_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng Manlalaro ng Epic`)
};

const fr_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note des joueurs Epic`)
};

const it_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione giocatori Epic`)
};

const hu_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic játékosok értékelése`)
};

const nl_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Spelersbeoordeling`)
};

const no_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Spillervurdering`)
};

const pl_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena graczy Epic`)
};

const pt_br2_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação dos jogadores da Epic`)
};

const pt_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação de jogadores Epic`)
};

const ro_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare jucători Epic`)
};

const fi_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-pelaajien arvio`)
};

const sv_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-spelarbetyg`)
};

const vi_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng người chơi Epic`)
};

const tr_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Oyuncu Puanı`)
};

const cs_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení hráčů Epic`)
};

const bg_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка на играчите на Epic`)
};

const ru_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг игроков Epic Games`)
};

const uk_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг гравців Epic`)
};

const ar_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييم لاعبي Epic`)
};

const hi_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic प्लेयर्स रेटिंग`)
};

const th_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนผู้เล่น Epic`)
};

const ja_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic プレイヤーレーティング`)
};

const zh_cn2_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic玩家评分`)
};

const zh_hant1_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic玩家評分`)
};

const ko_offerdetail_overview_epicrating2 = /** @type {(inputs: Offerdetail_Overview_Epicrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic 플레이어 평점`)
};

/**
* | output |
* | --- |
* | "Epic Players Rating" |
*
* @param {Offerdetail_Overview_Epicrating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_epicrating2 = /** @type {((inputs?: Offerdetail_Overview_Epicrating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Epicrating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_epicrating2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_epicrating2(inputs)
	if (locale === "da") return da_offerdetail_overview_epicrating2(inputs)
	if (locale === "de") return de_offerdetail_overview_epicrating2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_epicrating2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_epicrating2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_epicrating2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_epicrating2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_epicrating2(inputs)
	if (locale === "it") return it_offerdetail_overview_epicrating2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_epicrating2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_epicrating2(inputs)
	if (locale === "no") return no_offerdetail_overview_epicrating2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_epicrating2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_epicrating2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_epicrating2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_epicrating2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_epicrating2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_epicrating2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_epicrating2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_epicrating2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_epicrating2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_epicrating2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_epicrating2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_epicrating2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_epicrating2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_epicrating2(inputs)
	if (locale === "th") return th_offerdetail_overview_epicrating2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_epicrating2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_epicrating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_epicrating2(inputs)
	return ko_offerdetail_overview_epicrating2(inputs)
});
export { offerdetail_overview_epicrating2 as "offerDetail.overview.epicRating" }